import FollowUpRule from './FollowUpRule';
import SurveyQuestionType from './SurveyQuestionType';

class SurveyQuestion {
  public questionId: string;

  public questionType: SurveyQuestionType;

  public title: string;

  public description: string;

  public group: string;

  public variability: string;

  public identifier: string;

  public followUpRules: FollowUpRule[];

  public imageIdentifier: string;

  public info?: string;

  public suffix?: string;

  public allowSkipWithDefaultValue?: boolean;

  constructor(
    questionId: string,
    questionType: SurveyQuestionType,
    title: string,
    description: string,
    group: string,
    variability: string,
    identifier: string,
    followUpRules: FollowUpRule[],
    imageIdentifier: string,
    info?: string,
    suffix?: string,
    allowSkipWithDefaultValue?: boolean
  ) {
    this.questionId = questionId;
    this.questionType = questionType;
    this.title = title;
    this.description = description;
    this.group = group;
    this.variability = variability;
    this.identifier = identifier;
    this.followUpRules = followUpRules;
    this.imageIdentifier = imageIdentifier;
    this.info = info;
    this.suffix = suffix;
    this.allowSkipWithDefaultValue = allowSkipWithDefaultValue;
  }

  public static parse(object: any) {
    return new SurveyQuestion(
      object.QuestionId,
      object.QuestionType,
      object.Title,
      object.Description,
      object.Group,
      object.Variability,
      object.Identifier,
      object.FollowUpRules ?? [],
      object.ImageIdentifier,
      object.Info ?? undefined,
      object.Suffix ?? undefined,
      object.AllowSkipWithDefaultValue ?? undefined
    );
  }
}

export default SurveyQuestion;
